/* eslint-disable react-perf/jsx-no-new-object-as-prop */
import React from "react";
import SearchRefineMultiSelect from "~components/organisms/search/search_refine_multi_select/search_refine_multi_select";
import jobSearchRefineSelectDepartmentStyles from "./search_jobs_refine_select_department.styles";

const PLACEHOLDER_STRING = "Choose a department...";

const JobSearchRefineSelectDepartment = ({ ...rest }) => {
  return (
    <SearchRefineMultiSelect
      styles={jobSearchRefineSelectDepartmentStyles}
      placeholder={PLACEHOLDER_STRING}
      {...rest}
    />
  );
};

export default JobSearchRefineSelectDepartment;
